"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const r=require("./index61.js");var t=r.functionUncurryThis,o=t({}.isPrototypeOf);exports.objectIsPrototypeOf=o;
